import {Dispatch, SetStateAction} from 'react';
import {QuestionId} from '../store/navigation';
import {SurveyResponse} from './surveyResponse';

export interface RootQuestions {
  currentStep: number;
  totalSteps: number;
  questionType: string;
  url: string;
  title?: string;
}

export const QUESTIONIDS = {
  questionLanding: 'question_landing',
  questionOneName: 'q1_name',
  questionTwoYourVehicle: 'q2_your_vehicle',
  questionThreeVehicleUse: 'q3_vehicle_use',
  questionFourPassengers: 'q4_passengers',
  questionFiveTowingPreference: 'q5_towing_preference',
  questionSixFitsYourTrade: 'q6_fits_your_trade',
  questionSevenVehicleFeatures: 'q7_new_vehicle_features',
  questionEightAddress: 'q8_address',
  questionNineChargingType: 'q9_charging_type',
  questionTenChargingHome: 'q10_charging_home',
  questionElevenChargingWork: 'q11_charging_work',
  questionTwelveTravelDistance: 'q12_travel_distance',
  questionThirteenForm: 'q13_form',
  questionFourteenResults: 'q14_results',
} as const;

export type QuestionDataType = Record<
  QuestionId,
  Question | MultiSelectorQuestion | SingleSelectorQuestion | SliderQuestion
>;

export interface Question {
  subHeading?: string;
  id: QuestionId;
  title?: string;
  optional: boolean;
  progressValue: number;
  nextStepId?: QuestionId;
  setStepManual?: Dispatch<SetStateAction<number>>;
  showResultVehicle?: boolean;
  onShowResultVehicle?: () => void;
}

export interface MultiSelectorQuestion extends Question {
  optionMaxSelection: number;
  multiSelectOptions: MultiOption[];
  result?: Record<QuestionId, SurveyResponse[keyof SurveyResponse]>;
}

export interface SingleSelectorQuestion extends Question {
  singleSelectOptions: SingleOption[];
}

export interface SliderQuestion extends Question {
  min: number;
  max: number;
  increment: number;
  label?: string;
}
export enum EConditionDisplay {
  DISPLAY = 1,
  HIDDEN = 2,
  ALL = 0,
}
export type SingleOption = {
  label: string;
  value: string;
  isSelect?: boolean;
  nextStepId?: QuestionId;
  type?: EConditionDisplay;
  isDisabled?: boolean;
};

export type MultiOption = {
  label: string;
  value: string;
  isSelect?: boolean;
  nextStepId?: QuestionId;
  type?: EConditionDisplay;
  excludes?: string[];
  isDisabled?: boolean;
};
